import WizardRegistrationUsername from './container'
export { WizardRegistrationUsername }
export default WizardRegistrationUsername